import Vue from 'vue';
import Vuex from 'vuex';

import PurchaseCostsCalculator from '../Classes/PurchaseCostsCalculator';
import IncomeAndExpensesCalculator from '../Classes/IncomeAndExpensesCalculator';
import TaxFactorsCalculator from '../Classes/TaxFactorsCalculator';
import ResultsCalculator from '../Classes/ResultsCalculator';

let purchaseCostsCalc = new PurchaseCostsCalculator();
let incomeAndExpensesCalc = new IncomeAndExpensesCalculator();
let taxFactorsCalc = new TaxFactorsCalculator();
let resultsCalc = new ResultsCalculator();

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        purchaseCosts: purchaseCostsCalc,
        incomeAndExpenses: incomeAndExpensesCalc,
        taxFactors: taxFactorsCalc,
        results: resultsCalc,
        name: '',
        email: '',
        phone: '',
        userType: '',
        isModalVisible: true,
        wantsContact: false,
        purchasePriceEntered: true,
        propertySuburbEntered: true,
        weeklyRentalIncomeEntered: true,
        interestRateEntered: true
    },
    mutations: {
        initialiseStore(state) {

            if(localStorage.getItem('soundpropertycalculator')) {

                let retrievedCalculations = JSON.parse(localStorage.getItem('soundpropertycalculator'));

                state.purchaseCosts.copyOtherPurchaseCostsCalculator(retrievedCalculations.purchaseCosts);
                state.incomeAndExpenses.copyOtherIncomeAndExpensesCalculator(retrievedCalculations.incomeAndExpenses);
                state.taxFactors.copyOtherTaxFactorsCalculator(retrievedCalculations.taxFactors);
                state.results.copyOtherResultsCalculator(retrievedCalculations.results);
                state.name = retrievedCalculations.name;
                state.email = retrievedCalculations.email;
                state.phone = retrievedCalculations.phone;
                state.userType = retrievedCalculations.userType;
                state.isModalVisible = retrievedCalculations.isModalVisible;
                state.wantsContact = retrievedCalculations.wantsContact;
                if (state.wantsContact === undefined) {
                    state.wantsContact = false;
                }
            }
        },
        propertySuburbValueCalc(state, propertySuburb) {
            state.purchaseCosts.setPropertySuburb(propertySuburb);
            state.incomeAndExpenses.calcAnnualInterestOnEquityFunds(state.purchaseCosts.getDepositSource(), state.purchaseCosts.getTotal());
        },
        purchasePriceValueCalc(state, purchasePrice) {
            if (purchasePrice > 0 &&  !isNaN(purchasePrice)) {
                purchasePrice = Number(purchasePrice);

                state.purchaseCosts.setPurchasePrice(purchasePrice);
                state.incomeAndExpenses.calcRentalIncomeAmount(purchasePrice);
                state.incomeAndExpenses.calcRentalIncomePercentage(purchasePrice);
                state.incomeAndExpenses.calcLoanAmount(purchasePrice,  state.purchaseCosts.getDepositAmount());
                state.incomeAndExpenses.calcLoanToValueRatio(purchasePrice);
                state.incomeAndExpenses.calcAnnualInterestOnEquityFunds(state.purchaseCosts.getDepositSource(), state.purchaseCosts.getTotal());
                state.results.calcWeeklyRentalIncome(state.incomeAndExpenses.getRentalIncomeAnnual());
                state.results.calcAnnualRentalIncome(state.incomeAndExpenses.getRentalIncomeAnnual());
                state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcWeeklyPostDeprecation(state.taxFactors.getEstimatedAmount(), state.incomeAndExpenses.getLendersMortgageInsurance());
                state.results.calcAnnualPostDeprecation(state.taxFactors.getEstimatedAmount(), state.incomeAndExpenses.getLendersMortgageInsurance());
                state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.setLoanBalanceTable(state.incomeAndExpenses.getLoanBalanceTable());
                state.results.setPropertyValueYear1(purchasePrice);
                state.results.setLoanYear1(state.incomeAndExpenses.getLoanAmount());
            }
        },
        depositSourceValueCalc(state, depositSource) {
            state.purchaseCosts.setDepositSource(depositSource);
            state.incomeAndExpenses.calcAnnualInterestOnEquityFunds(depositSource, state.purchaseCosts.getTotal());
            state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
            state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
            state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
            state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
        },
        depositAmountValueCalc(state, depositAmount) {
            if (state.purchaseCosts.getPurchasePrice() > 0 && !isNaN(depositAmount)) {
                state.purchaseCosts.setDepositAmount(depositAmount);
                state.incomeAndExpenses.calcLoanAmount(state.purchaseCosts.getPurchasePrice(),  depositAmount);
                state.incomeAndExpenses.calcLoanToValueRatio(state.purchaseCosts.getPurchasePrice());
                state.incomeAndExpenses.calcAnnualInterestOnEquityFunds(state.purchaseCosts.getDepositSource(), state.purchaseCosts.getTotal());
                state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.setLoanBalanceTable(state.incomeAndExpenses.getLoanBalanceTable());
                state.results.setPropertyValueYear1(state.purchaseCosts.getPurchasePrice());
                state.results.setLoanYear1(state.incomeAndExpenses.getLoanAmount());
            }
        },
        depositPercentageValueCalc(state, depositPercentage) {

            if (state.purchaseCosts.getPurchasePrice() > 0 && !isNaN(depositPercentage)) {
                state.purchaseCosts.setDepositPercentage(depositPercentage);
                state.incomeAndExpenses.calcLoanAmount(state.purchaseCosts.getPurchasePrice(),  state.purchaseCosts.getDepositAmount());
                state.incomeAndExpenses.calcLoanToValueRatio(state.purchaseCosts.getPurchasePrice());
                state.incomeAndExpenses.calcAnnualInterestOnEquityFunds(state.purchaseCosts.getDepositSource(), state.purchaseCosts.getTotal());
                state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.setLoanBalanceTable(state.incomeAndExpenses.getLoanBalanceTable());
                state.results.setPropertyValueYear1(state.purchaseCosts.getPurchasePrice());
                state.results.setLoanYear1(state.incomeAndExpenses.getLoanAmount());
            }
        },
        stampDutyValueCalc(state, stampDuty) {
            state.purchaseCosts.setStampDuty(stampDuty);
            state.incomeAndExpenses.calcAnnualInterestOnEquityFunds(state.purchaseCosts.getDepositSource(), state.purchaseCosts.getTotal());
            state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
            state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
            state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
            state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
        },
        legalFeesValueCalc(state, legalFees) {
            if (legalFees >= 0 && !isNaN(legalFees)) {
                state.purchaseCosts.setLegalFees(legalFees);
                state.incomeAndExpenses.calcAnnualInterestOnEquityFunds(state.purchaseCosts.getDepositSource(), state.purchaseCosts.getTotal());
                state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
            }
        },
        prepurchaseInspectionsValueCalc(state, prepurchaseInspections) {
            if (prepurchaseInspections >= 0 && !isNaN(prepurchaseInspections)) {
                state.purchaseCosts.setPrepurchaseInspections(prepurchaseInspections);
                state.incomeAndExpenses.calcAnnualInterestOnEquityFunds(state.purchaseCosts.getDepositSource(), state.purchaseCosts.getTotal());
                state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
            }
        },
        otherFeesCostsValueCalc(state, otherFeesCosts) {
            if (otherFeesCosts >= 0 && !isNaN(otherFeesCosts)) {
                state.purchaseCosts.setOtherFeesCosts(otherFeesCosts);
                state.incomeAndExpenses.calcAnnualInterestOnEquityFunds(state.purchaseCosts.getDepositSource(), state.purchaseCosts.getTotal());
                state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
            }
        },
        totalValueCalc(state) {
            state.purchaseCosts.setTotal();
            state.incomeAndExpenses.calcAnnualInterestOnEquityFunds(state.purchaseCosts.getDepositSource(), state.purchaseCosts.getTotal());
        },
        rentalIncomeAmountValueCalc(state, rentalIncomeAmount) {

            if (state.purchaseCosts.getPurchasePrice() > 0 && !isNaN(rentalIncomeAmount)) {
                state.incomeAndExpenses.setRentalIncomeAmount(rentalIncomeAmount);

                state.incomeAndExpenses.calcRentalIncomePercentage(state.purchaseCosts.getPurchasePrice());
                state.results.calcWeeklyRentalIncome(state.incomeAndExpenses.getRentalIncomeAnnual());
                state.results.calcAnnualRentalIncome(state.incomeAndExpenses.getRentalIncomeAnnual());
                state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
            }
        },
        rentalIncomePercentageValueCalc(state, rentalIncomePercentage) {

            if (state.purchaseCosts.getPurchasePrice() > 0 && !isNaN(rentalIncomePercentage)) {
                state.incomeAndExpenses.setRentalIncomePercentage(rentalIncomePercentage);

                state.incomeAndExpenses.calcRentalIncomeAnnualByRentalIncomePercentage(state.purchaseCosts.getPurchasePrice());
                state.results.calcWeeklyRentalIncome(state.incomeAndExpenses.getRentalIncomeAnnual());
                state.results.calcAnnualRentalIncome(state.incomeAndExpenses.getRentalIncomeAnnual());
                state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
            }
        },
        rentalIncomeAnnualValueCalc(state, rentalIncomeAnnual) {
            state.incomeAndExpenses.setRentalIncomeAnnual(rentalIncomeAnnual);
            state.results.calcWeeklyRentalIncome(rentalIncomeAnnual);
            state.results.calcAnnualRentalIncome(state.incomeAndExpenses.getRentalIncomeAnnual());
        },
        councilRatesValueCalc(state, councilRates) {

            if (councilRates >= 0 && !isNaN(councilRates)) {
                state.incomeAndExpenses.setCouncilRates(councilRates);
                state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
            }
        },
        buildingInsuranceOrStrataFeesValueCalc(state, buildingInsuranceOrStrataFees) {

            if (buildingInsuranceOrStrataFees >= 0 && !isNaN(buildingInsuranceOrStrataFees)) {
                state.incomeAndExpenses.setBuildingInsuranceOrStrataFees(buildingInsuranceOrStrataFees);
                state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
            }
        },
        otherExpensesValueCalc(state, otherExpenses) {

            if (otherExpenses >= 0 && !isNaN(otherExpenses)) {
                state.incomeAndExpenses.setOtherExpenses(otherExpenses);
                state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
            }
        },
        propertyManagementValueCalc(state, propertyManagement) {

            if (propertyManagement >= 0 && !isNaN(propertyManagement)) {
                state.incomeAndExpenses.setPropertyManagement(propertyManagement);
            }
        },
        vacancyPeriodValueCalc(state, vacancyPeriod) {

            if (vacancyPeriod >= 0 && !isNaN(vacancyPeriod)) {
                state.incomeAndExpenses.setVacancyPeriod(vacancyPeriod);
                state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
            }
        },
        totalAnnualExpensesValueCalc(state, totalCalc) {
            state.incomeAndExpenses.setTotal(totalCalc);
        },
        loanAmountValueCalc(state, loanAmount) {
            state.incomeAndExpenses.setLoanAmount(loanAmount);
            if (state.purchaseCosts.getPurchasePrice() > 0 && !isNaN(loanAmount)) {
                state.incomeAndExpenses.calcLoanToValueRatio(state.purchaseCosts.getPurchasePrice());
                state.incomeAndExpenses.calcAnnualInterestOnEquityFunds(state.purchaseCosts.getDepositSource(), state.purchaseCosts.getTotal());
                state.results.setLoanBalanceTable(state.incomeAndExpenses.getLoanBalanceTable());
                state.results.setLoanYear1(state.incomeAndExpenses.getLoanAmount());
            }
            state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
            state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
            state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcWeeklyPostDeprecation(state.taxFactors.getEstimatedAmount(), state.incomeAndExpenses.getLendersMortgageInsurance());
            state.results.calcAnnualPostDeprecation(state.taxFactors.getEstimatedAmount(), state.incomeAndExpenses.getLendersMortgageInsurance());
            state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
            state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
        },
        loanToValueRatioValueCalc(state, loanToValueRatio) {
            state.incomeAndExpenses.setLoanToValueRatio(loanToValueRatio);
            state.incomeAndExpenses.calcAnnualInterestOnEquityFunds(state.purchaseCosts.getDepositSource(), state.purchaseCosts.getTotal());
            state.results.calcWeeklyPostDeprecation(state.taxFactors.getEstimatedAmount(), state.incomeAndExpenses.getLendersMortgageInsurance());
            state.results.calcAnnualPostDeprecation(state.taxFactors.getEstimatedAmount(), state.incomeAndExpenses.getLendersMortgageInsurance());
            state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
            state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
        },
        loanTypeValueCalc(state, loanType) {
            state.incomeAndExpenses.setLoanType(loanType);
            state.results.setLoanType(loanType);
            state.results.setLoanBalanceTable(state.incomeAndExpenses.getLoanBalanceTable());
            state.results.setPropertyValueYear1(state.purchaseCosts.getPurchasePrice());
            state.results.setLoanYear1(state.incomeAndExpenses.getLoanAmount());
            state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
            state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
            state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
            state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
        },
        loanTermValueCalc(state, loanTerm) {

            if (loanTerm >= 0 && !isNaN(loanTerm)) {
                state.incomeAndExpenses.setLoanTerm(loanTerm);
                state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.setLoanTerm(loanTerm);
            }
        },
        lendersMortgageInsuranceValueCalc(state, lendersMortgageInsurance) {
            state.incomeAndExpenses.setLendersMortgageInsurance(lendersMortgageInsurance);
            state.incomeAndExpenses.calcAnnualInterestOnEquityFunds(state.purchaseCosts.getDepositSource(), state.purchaseCosts.getTotal());
            state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
            state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
            state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcWeeklyPostDeprecation(state.taxFactors.getEstimatedAmount(), state.incomeAndExpenses.getLendersMortgageInsurance());
            state.results.calcAnnualPostDeprecation(state.taxFactors.getEstimatedAmount(), state.incomeAndExpenses.getLendersMortgageInsurance());
            state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
            state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
        },
        interestRateValueCalc(state, interestRate) {

            if (interestRate >= 0 && !isNaN(interestRate)) {
                state.incomeAndExpenses.setInterestRate(interestRate);
                state.incomeAndExpenses.calcAnnualInterestOnEquityFunds(state.purchaseCosts.getDepositSource(), state.purchaseCosts.getTotal());
                state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
                state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
                state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.setInterestRate(interestRate);
                state.results.setLoanBalanceTable(state.incomeAndExpenses.getLoanBalanceTable());
                state.results.setPropertyValueYear1(state.purchaseCosts.getPurchasePrice());
                state.results.setLoanYear1(state.incomeAndExpenses.getLoanAmount());
            }
        },
        annualInterestRepaymentsValueCalc(state, annualInterestRepayments) {
            state.incomeAndExpenses.setAnnualInterestRepayments(annualInterestRepayments);
            state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
            state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
            state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
            state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
        },
        annualPrincipalRepaymentsValueCalc(state, annualPrincipalRepayments) {
            state.incomeAndExpenses.setAnnualPrincipalRepayments(annualPrincipalRepayments);
            state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
            state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
            state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
            state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
        },
        annualInterestOnEquityFundsValueCalc(state, annualInterestOnEquityFunds) {
            state.incomeAndExpenses.setAnnualInterestOnEquityFunds(annualInterestOnEquityFunds);
            state.results.calcWeeklyPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
            state.results.calcAnnualPreTotalExpenses(state.incomeAndExpenses.getTotalExpenses());
            state.results.calcWeeklyPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcAnnualPostTotalClaimableExpenses(state.incomeAndExpenses.getTotalExpenses(), state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
            state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
        },
        totalExpensesValueCalc(state, totalExpenses) {
            state.incomeAndExpenses.setTotalExpenses(totalExpenses);
            state.results.calcWeeklyPreTotalExpenses(totalExpenses);
            state.results.calcAnnualPreTotalExpenses(totalExpenses);
            state.results.calcWeeklyPostTotalClaimableExpenses(totalExpenses, state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcAnnualPostTotalClaimableExpenses(totalExpenses, state.incomeAndExpenses.getAnnualPrincipalRepayments());
            state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
            state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
        },
        individualGrossIncomeValueCalc(state, individualGrossIncome) {
            if (individualGrossIncome >= 0 && !isNaN(individualGrossIncome)) {
                state.taxFactors.setIndividualGrossIncome(individualGrossIncome);
                state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
                state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
            }
        },
        propertyBoughtValueCalc(state, propertyBought) {
            state.taxFactors.setPropertyBought(propertyBought);
        },
        propertyTypeValueCalc(state, propertyType) {
            state.taxFactors.setPropertyType(propertyType);
        },
        purchaseDateValueCalc(state, purchaseDate) {
            state.taxFactors.setPurchaseDate(purchaseDate);
        },
        constructionYearValueCalc(state, constructionYear) {
            state.taxFactors.setConstructionYear(constructionYear);
        },
        nearestCapitalCityValueCalc(state, nearestCapitalCity) {
            state.taxFactors.setNearestCapitalCity(nearestCapitalCity);
        },
        standardOfFinishValueCalc(state, standardOfFinish) {
            state.taxFactors.setStandardOfFinish(standardOfFinish);
        },
        estimatedAmountValueCalc(state, estimatedAmount) {
            state.taxFactors.setEstimatedAmount(estimatedAmount);
            state.results.calcWeeklyPostDeprecation(estimatedAmount, state.incomeAndExpenses.getLendersMortgageInsurance());
            state.results.calcAnnualPostDeprecation(estimatedAmount, state.incomeAndExpenses.getLendersMortgageInsurance());
            state.results.calcWeeklyPostTaxRebate(state.taxFactors.getTaxRate());
            state.results.calcAnnualPostTaxRebate(state.taxFactors.getTaxRate());
        },
        successfullyCalculatedDepreciationAmount(state, successfullyCalculatedDepreciationAmount) {
            state.taxFactors.setSuccessfullyCalculated(successfullyCalculatedDepreciationAmount);
        },
        capitalGrowthValueCalc(state, capitalGrowth) {

            if (capitalGrowth >= 0 && !isNaN(capitalGrowth)) {
                state.results.setCapitalGrowth(capitalGrowth);
                state.results.setLoanBalanceTable(state.incomeAndExpenses.getLoanBalanceTable());
                state.results.setPropertyValueYear1(state.purchaseCosts.getPurchasePrice());
                state.results.setLoanYear1(state.incomeAndExpenses.getLoanAmount());
            }
        },
        phoneNumber(state, phone) {
            state.phone = phone;
        },
        email(state, email) {
            state.email = email;
        },
        name(state, name) {
            state.name = name;
        },
        userType(state, userType) {
            state.userType = userType;
        },
        modalVisibility(state, isModalVisible) {
            state.isModalVisible = isModalVisible;
        },
        wantsContact(state, wantsContact) {
            state.wantsContact = wantsContact;
        },
        purchasePriceEntered(state, purchasePriceEntered) {
            state.purchasePriceEntered = purchasePriceEntered;
        },
        propertySuburbEntered(state, propertySuburbEntered) {
            state.propertySuburbEntered = propertySuburbEntered;
        },
        weeklyRentalIncomeEntered(state, weeklyRentalIncomeEntered) {
            state.weeklyRentalIncomeEntered = weeklyRentalIncomeEntered;
        },
        interestRateEntered(state, interestRateEntered) {
            state.interestRateEntered = interestRateEntered;
        },
    }
});


// WEBPACK FOOTER //
// ./src/store/CashflowCalculations.js